// extracted by mini-css-extract-plugin
export default {"section":"styles_section__UuA80","sectionBackgroundImage":"styles_sectionBackgroundImage__zSNw0"};